let config = {           
    publishingGroups: !location.host.startsWith('localhost') ? ['Type','Fabric','Dimensions','Category','Ratio'] : ['Category'],
    filters:[
        {text:'Search',operation:''},
        //{tag:'Type'},
        //{tag:'Fabric'},
        //{tag:'Dimensions'},
        {tag:'Category'},
    ],
    pageSize: 24,
    orderBy: '-CreatedOn,Id',
    sortOptions: {
        'Id': 'Sku: Low to High',
        '-Id': 'Sku: High to Low',
        'ManufacturerNumber,Id': 'Item #: Low to High',
        '-ManufacturerNumber,Id': 'Item #: High to Low',
        'ShortDescription,Id': 'Description: A to Z',
        '-ShortDescription,Id': 'Description: Z to A',
        'Cost,Id': 'Cost: Low to High',
        '-Cost,Id': 'Cost: High to Low',
        'WholesalePrice,Id': 'Price: Low to High',
        '-WholesalePrice,Id': 'Price: High to Low',
        'CreatedOn,Id': 'Created: Newest',
        '-CreatedOn,Id': 'Created: Oldest',
        'Status,Id': 'Status: A to Z',
        '-Status,Id': 'Status: Z to A',
    }
};

export default config;